module.exports = __webpack_public_path__ + "img/arw-sx.b90204d6.svg";